import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { BACKEND_MAIN_URL } from '../config';

// The link at the bottom of UpyaChat's news emails. A button rather than an automatic unsubscribe:
// mail scanners open links on their own and must not unsubscribe anyone. Bilingual on purpose
// (like the account emails): it is reached from an email, before any language choice.
// Unsubscribing stops news only: official messages about the account still arrive.
export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState('ready');   // ready | busy | done | back | error
  const user = params.get('u');
  const token = params.get('t');
  const send = async (path, next) => {
    setState('busy');
    try {
      await axios.post(`${BACKEND_MAIN_URL}/api/${path}`, { u: user, t: token });
      setState(next);
    } catch { setState('error'); }
  };
  return <main className="unsubscribe-page">
    <h1>UpyaChat</h1>
    {state === 'done' ? <>
      <p role="status">
        You will no longer receive UpyaChat news. Official messages about your account will still reach you.<br />
        Vous ne recevrez plus les actualités d&apos;UpyaChat. Les messages officiels sur votre compte vous parviendront toujours.
      </p>
      <button type="button" className="unsubscribe-link" onClick={() => send('resubscribe', 'back')}>
        Changed your mind? Subscribe again / Vous avez changé d&apos;avis ? Se réabonner</button>
    </> : state === 'back' ? <p role="status">
      You will receive UpyaChat news again.<br />Vous recevrez de nouveau les actualités d&apos;UpyaChat.
    </p> : !user || !token || state === 'error' ? <p role="alert">
      This link is not valid. Write to info@upyachat.com and we will take care of it.<br />
      Ce lien n&apos;est pas valide. Écrivez à info@upyachat.com et nous nous en occuperons.
    </p> : <>
      <p>Stop receiving UpyaChat news (articles, announcements)? Official messages about your account will still reach you.<br />
        Ne plus recevoir les actualités d&apos;UpyaChat (articles, annonces) ? Les messages officiels sur votre compte vous parviendront toujours.</p>
      <button type="button" className="unsubscribe-button" onClick={() => send('unsubscribe', 'done')} disabled={state === 'busy'}>
        Unsubscribe / Me désabonner</button>
    </>}
  </main>;
}
